export default __webpack_public_path__ + "static/date-label-anatomy-light-31b1f329e5a027d325348b6b0509f5c9.png";